module.exports = __webpack_public_path__ + "img/dashboard.7787f75f.jpg";